export enum ExtendedHttpHeader {
  AadUserAuthorization = "x-ms-authorization-aaduser",
  CartSessionId = "x-ms-ucs-sid",
  ContentLength = "Content-Length",
  ContinuationToken = "x-ms-ct",
  Forwarded = "Forwarded",
  ForwardedFor = "X-Forwarded-For",
  MsApiVersion = "X-MS-API-Version",
  MuidAuthorization = "x-authorization-muid",
  /** Akamai header representing the originating client's IP */
  TrueClientIp = "True-Client-IP",
  UserAgent = "User-Agent",
  XblContractVersion = "X-XBL-Contract-Version",
  XblExperiments = "xbl-experiments",
  ValidationField = "x-validation-field-1",
  VectorId = "X-MS-Vector-Id",
}

export const expiresHeader = "expires";
